import { MenuItem, Menu } from '@mui/material';
import styled from 'styled-components';

import { RichTextInput } from 'ui/TextInput';

import { CancelButton } from 'components/Button';

export const EditTaskRowName = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 20px 0 5px 0;
`;

export const StyledMenuItem = styled(MenuItem)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
  width: 100%;
`;

export const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    width: 45%;
  }
`;

export const StyledTextInput = styled(RichTextInput)`
  p {
    margin: 0.5rem;
  }
`;

export const TypeButton = styled(CancelButton)`
  color: ${({ theme }) => theme.palette.text.primary};
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  border-radius: 4px;
  justify-content: flex-start;

  &.MuiButton-sizeMedium {
    height: 56px;

    &:hover {
      background: white;
    }
  }

  &.MuiButton-text {
    font-weight: 400;
  }

  &:hover {
    border: 1px solid ${({ theme }) => theme.palette.grey[700]};
  }
`;
